import { render, staticRenderFns } from "./ModalAiChat.vue?vue&type=template&id=1b47d0ba"
import script from "./ModalAiChat.vue?vue&type=script&lang=js"
export * from "./ModalAiChat.vue?vue&type=script&lang=js"
import style0 from "./ModalAiChat.vue?vue&type=style&index=0&id=1b47d0ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports